import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { GET_STATISTICS_ACCOUNT_EXCEL_API_URL, GET_STATISTICS_ACTUALIZATION_HOUSE_API_URL, GET_STATISTICS_ACTUALIZATION_OPTIC_API_URL, GET_STATISTICS_ACTUALIZATION_OPTIC_EXCEL_API_URL, GET_STATISTICS_ACTUALIZATION_OPTIC_RAPORT_EXCEL_API_URL, GET_STATISTICS_CABLE_ACCOUNT_API_URL, GET_STATISTICS_CABLE_CANTON_API_URL, GET_STATISTICS_CABLE_EXCEL_API_URL, GET_STATISTICS_INFRASTRUCTURE_ACCOUNT_API_URL } from '../OpticApiConfig';
import { loadingCanton } from '../LoadingData/LoadingDataTerritory';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


//#region STYLE
const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '16px',
    border: '1px solid #ffffff',
    
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};
//#endregion 

const StatisticOptic = (user) => 
  {

  const [selectedCanton, setSelectedCanton] = useState('');
  const [resultCantonOptic, setCantonOptic] = useState([]);
  const [resultTotalHouses, setTotalHouses] = useState([]);
  const [resultCable, setResultCable] = useState([]);
  const [resultCableAccount, setResultCableAccount] = useState([]);
  const [resultComponent, setResultComponent] = useState({});
  const [error, setError] = useState(null);  
  const token = localStorage.getItem('token');
  const [canton, setCanton] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [loading, setLoading] = useState(false);


const handleDownload = async () => {
  setLoading(true);
  try {
    const newDate = new Date(selectedDate);
     newDate.setDate(newDate.getDate()); // добавить 1 день
    // newDate.setDate(newDate.getDate()); // добавить 1 день
    const formattedDate = newDate.toISOString().split("T")[0];

    const token = localStorage.getItem("token");

    // Первый запрос
    const response1 = await axios.get(GET_STATISTICS_ACTUALIZATION_OPTIC_EXCEL_API_URL, {
      params: { date: formattedDate },
      headers: { Authorization: `Bearer ${token}` },
    });

    const data1 = response1.data.map(item => ({
      "Округ": item.canton,
      "Регион": item.region,
      "Кол-во оптики": item.highwayLineIdCount,
      "Актуализировано": item.documentCount,
    }));

    if (!data1 || data1.length === 0) {
      alert("Нет данных по актуализации оптики");
      setLoading(false);
      return;
    }

    // Второй запрос
    // const response2 = await axios.get(GET_STATISTICS_ACTUALIZATION_OPTIC_RAPORT_EXCEL_API_URL, {
    //   params: { date: formattedDate },
    //   headers: { Authorization: `Bearer ${token}` },
    // });

    // const data2 = response2.data.map(item => ({
    //   "Округ": item.canton,
    //   "Регион": item.region,
    //   "Воздушка(всего)": item.highwayLineIdCount,
    //   "Актуализ.(всего)": item.documentCount,
    //   "% (всего)": item.percentTotal,
    //   "Воздушка/неделю": item.last7Days_CableCount,
    //   "Актуализ./неделю": item.last7Days_DocumentCount,
    // }));

    // Создаем книгу Excel
    const workbook = XLSX.utils.book_new();

    const worksheet1 = XLSX.utils.json_to_sheet(data1);
    //const worksheet2 = XLSX.utils.json_to_sheet(data2);

    XLSX.utils.book_append_sheet(workbook, worksheet1, "Общая статистика");
    //XLSX.utils.book_append_sheet(workbook, worksheet2, "Рапорт ИС");

   const exportDate = new Date(newDate);
    exportDate.setDate(exportDate.getDate() - 1);
    const exportDateStr = exportDate.toISOString().split("T")[0];

    XLSX.writeFile(workbook, `Статистика_оптики_${exportDateStr}.xlsx`);
  } catch (error) {
    console.error("Ошибка при загрузке:", error);
    alert("Произошла ошибка при получении данных");
  } finally {
    setLoading(false);
  }
};


//   const handleDownload = async () => {
//     setLoading(true);
//     try {
    
//       const newDate = new Date(selectedDate);
//       newDate.setDate(newDate.getDate() + 1); // Добавляем 1 день


//       const formattedDate = newDate.toISOString().split("T")[0];

//       const response = await axios.get(`${GET_STATISTICS_ACTUALIZATION_OPTIC_EXCEL_API_URL}`, {
//         params: { date: formattedDate },
//         headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }, 
//       });

//       // Переименование ключей
//       const formattedData = response.data.map(item => ({
//         "Округ": item.canton,
//         "Регион": item.region,
//         "Ветка": item.area,
//         "Кол. оптики": item.highwayLineIdCount,
//         "Актуализировано": item.documentCount,       
//       }));
 
//       if (!response.data || response.data.length === 0) {
//         alert("Нет данных за выбранную дату");
//         setLoading(false);
//         return;
//       }

   
//     const worksheetAccount = XLSX.utils.json_to_sheet(formattedData);
    
// const workbook = XLSX.utils.book_new();
// XLSX.utils.book_append_sheet(workbook, worksheetAccount, "Статистика актуализация");


// const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
// const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
// const newDate2 = new Date(selectedDate);
// newDate.setDate(newDate2.getDate() - 1); // Вычитаем 1 день

// // Форматируем дату в ISO-формате и извлекаем только дату
// const formattedDateMinusOne = newDate2.toISOString().split("T")[0];

// saveAs(blob, `Статистика_актуализация_${formattedDateMinusOne}.xlsx`);

//     } catch (error) {
//       console.error("Ошибка загрузки данных:", error);
//       alert("Ошибка загрузки данных");
//     }
//     setLoading(false);
//   };
  

   useEffect(() => {
        loadingCanton(setCanton); 
      }, []); 
  

   // Обработчик нажатия на кнопку
   const handleButtonClick = async () => {
    if (!selectedCanton) {
      setError('Пожалуйста, выберите округ.');
      return;
    }
  
    try {
      setError(null); 
  
      const response = await axios.get(GET_STATISTICS_ACTUALIZATION_OPTIC_API_URL, {
        headers: { Authorization: `Bearer ${token}` },
        params: { canton: selectedCanton }
      });
  
      setCantonOptic(response.data);
      setIsVisible(true);
    } catch (error) {
      console.error(error);
      setError('Произошла ошибка при загрузке данных.');
    }
  };


 

  return (
    <>
    
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>  
    <hr className="horizontalLineDrawer" style={{ marginTop: "5px" }} />

      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <label className='textTitleDrawer' style={{ fontSize: "20px", marginLeft: "10px", textShadow: '2px 2px 4px rgb(39, 39, 39)' }}>Статистика актуализации оптики</label>
      <Select
            className="selectSearchDrawer"
            options={canton.map(option => ({ value: option, label: option }))}
            isSearchable={true}
            styles={customStyles}
            placeholder="Округ"
            onChange={(selectedOption) => setSelectedCanton(selectedOption.value)} 
          />
          <button 
            className='buttonAutoTopology' 
            style={{ marginTop: "0px", padding: "10px" }}
            onClick={handleButtonClick} 
          >
            Загрузить
          </button>

          <div className='address-summary'
            style={{
              textAlign: "center",
              paddingTop: "5px",
              paddingBottom: "5px",
              paddingLeft: "20px",
              paddingRight: "20px",
              marginLeft: "100px",  
              float: "right", 
              display: "flex",
              borderRadius: "10px",
              flexDirection: "row", 
              alignItems: "center", 
            }}
          >
          <DatePicker
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            dateFormat="yyyy-MM-dd"
            placeholderText="Выберите дату"
            className="inputDescriptionModal"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            shouldCloseOnSelect={false}
            open={false}
          />

          <button className='buttonAutoTopology' onClick={handleDownload} disabled={loading} style={{ marginLeft: "10px",  marginTop: "0px" }}>
            {loading ? "Скачивание..." : "Скачать Excel"}
          </button>
        </div>
        
      </div>
      <hr className="horizontalLineDrawer" style={{ marginTop: "0px" }} />
    </div>
   
{isVisible && (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>

      {/* Актуализация домов */}
      <div  className="scroll-container" style={{ flex: 1, marginTop: '0px', maxWidth:"600px",   height: '80vh', overflowY: 'auto', paddingBottom: '10px' }}>       
        <table className="results-table"> 
          <thead>
          <tr>
          <td colSpan="5" 
       style={{
        textAlign: 'center',
        fontSize: '14px',
        fontWeight: 'bold',      
        backgroundImage: 'linear-gradient(to right, rgb(56, 56, 56), #434343)',
      }}>
         
    {/* {resultCantonOptic.} | Домов: {resultTotalHouses.houseCount} | Внесено: {resultTotalHouses.actualize} */} 
   </td>
          </tr>
            <tr>
            <th>Округ</th>
              <th>Регион</th>
              <th>Ветка</th>
              <th>Кол. оптики</th>
              <th>Актуализировано</th>
              <th>%</th>
            </tr>
          </thead>
          <tbody>
            {resultCantonOptic.length === 0 ? (
              <tr>
                <td colSpan="5" className="no-data">Нет данных для отображения</td>
              </tr>
            ) : (
              resultCantonOptic.map((item, index) => {
                const percentage = item.documentCount > 0
                ? ((item.documentCount / item.highwayLineIdCount) * 100).toFixed(2) + "%"
                : "0%";
                return (
                  <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"} style={{textShadow: '2px 2px 4px rgb(39, 39, 39)'}}>
                     <td>{item.canton}</td>
                    <td>{item.region}</td>
                    <td >
                      {item.area}
                    </td>
                    <td style={{ color: item.highwayLineIdCount === 0 ? '#e0656f' :  '#5bcc87'  }}>
                      {item.highwayLineIdCount}
                    </td>
                    <td style={{ color: item.documentCount === 0 ? '#e0656f' :  '#5bcc87'  }}>
                      {item.documentCount}
                    </td>
                    <td 
                      className="total-cell" 
                      style={{ 
                        color: item.total === 0 
                          ? '#e0656f' 
                          : percentage === "100.00%" 
                            ? '#5bcc87' 
                            : percentage >= "61.00%" 
                              ? '#ffa500' 
                              : '#e0656f' 
                      }}
                    >
                      {percentage}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

       


   
  </div>
       )}
      </>
  );
};

export default StatisticOptic;
